export default "1cc9aa4c461dad41.png"